<script>
import { Bar } from 'vue-chartjs';
import { toCurrency } from '@/utils/etc.js';
import { apiGetAccountReceived } from '@/api/statistics/statistics.js';

export default {
	extends: Bar,
	props: {
		unit: String,
		year: Number,
		month: Number,
	},
	computed: {
		from_date: {
			get: function() {
				if (this.unit.toUpperCase() === 'DAY') return this.year + '-' + this.month + '-' + '01';
				else if (this.unit.toUpperCase() === 'MONTH') return this.year + '-01-01';
				else return null;
			},
		},
		to_date: {
			get: function() {
				let date = null;
				if (this.unit.toUpperCase() === 'DAY') date = new Date(this.year, this.month, 0);
				else if (this.unit.toUpperCase() === 'MONTH') date = new Date(this.year, 11, 31);
				else return null;

				return date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1) + '-' + date.getDate();
			},
		},
	},
	async mounted() {
		let { data } = await apiGetAccountReceived(this.unit, this.from_date, this.to_date);

		let account_received_data = data.map(el => el.account_received);
		let sum_account_received = 0;
		account_received_data.forEach(el => {
			if (el) sum_account_received += el;
		});
		let labels = data.map(el => {
			if (this.unit === 'DAY') return el.date.substr(3, 2);
			else if (this.unit === 'MONTH') return el.date.substr(0, 2);
		});

		this.renderChart(
			{
				labels,
				datasets: [
					{
						label: 'Account Received',
						backgroundColor: '#FFA100',
						data: account_received_data,
					},
				],
			},
			{
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							ticks: {
								minRotation: 45,
								callback: value => '$' + toCurrency(value),
							},
						},
					],
				},
				plugins: {
					datalabels: {
						display: false,
					},
				},
			},
		);

		this.$emit('emitSumData', { 'ACCOUNT RECEIVED': sum_account_received });

		this.$nextTick(() => {
			this.$refs.canvas.style.height = '350px';
		});
	},
};
</script>
